/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { InlineEdit } from "../../components/InlineEdit";
import { Button } from "../../components/Button";
import { useParams } from "react-router-dom";
import useSaveTemplate from "../../utils/customHooks";
import { SpinnerOverlay } from "../../utils/SpinnerOverlay";

const Wz02: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  const [text1, setText1] = useState<string>("Baśnie i Bajki");
  const [text2, setText2] = useState<string>("Joasi");
  const [text3, setText3] = useState<string>("Na pamiątkę Chrztu Świętego");
  const [text4, setText4] = useState<string>("Ojciec Chrzestny");
  const [fontSizeText1, setFontSizeText1] = useState<number>(78);
  const [fontSizeText2, setFontSizeText2] = useState<number>(78);
  const [fontSizeText3, setFontSizeText3] = useState<number>(25);
  const [fontSizeText4, setFontSizeText4] = useState<number>(25);
  const { saveTemplate, isSaving } = useSaveTemplate();

  const pdfWidth = "250mm"; // PDF width in mm
  const pdfHeight = "300mm"; // PDF height in mm (A4 size)
  const maxWidth = 600; // Maximum width for text

  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px 'BarlowLight', 'AveUtan'`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px 'BarlowLight', 'AveUtan'`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px 'BarlowLight', 'AveUtan'`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  useEffect(() => {
    setFontSizeText1(adjustFontSize(text1, fontSizeText1, 78, 20));
  }, [text1]);

  useEffect(() => {
    setFontSizeText2(adjustFontSize(text2, fontSizeText2, 78, 30));
  }, [text2]);

  useEffect(() => {
    setFontSizeText3(adjustFontSize(text3, fontSizeText3, 25, 15));
  }, [text3]);

  useEffect(() => {
    setFontSizeText4(adjustFontSize(text4, fontSizeText4, 25, 10));
  }, [text4]);

  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth,
        pdfHeight: pdfHeight,
        pdfNameFromUrl: pdfNameFromUrl,
      },
      null, // No image provided
      false // Disable the image requirement
    );
  };

  return (<div style={{
    width: "100%",
    height: "100%",
    backgroundColor: "#ffffff", padding: "60px",
    position: "relative",
  }}>
    {/* Spinner Overlay */}
    <SpinnerOverlay isVisible={isSaving} />
    <div style={{ position: "absolute", top: "10px", left: "0px", right: "0px", margin: "auto", color: "white", width: "480px", maxWidth: "100%", height: "70px", gap: "30px", display: "flex", alignItems: "center" }}>

        <Button onClick={handleSave} disabled={isSaving}>
          {isSaving ? "Zapisywanie..." : "Zapisz"}
        </Button>
    </div>

      <div
      id="printable-content"
      style={{
        position: "relative",
        width: pdfWidth,
        height: pdfHeight,
        fontFamily: "BarlowLight, AveUtan",
        backgroundColor: "#ffffff",
        margin: "auto",
        marginTop: "20px"
      }}
    >
        {/* Dynamic Text 1 */}
        <InlineEdit
          value={text1}
          setValue={setText1}
          classes="wz02-text wz02-text-1"
          style={{
            fontSize: `${fontSizeText1}px`,
            fontFamily: "AveUtan",
            textAlign: "center",
            position: 'absolute',
            top: '565px',
            left: '0',
            right: '0',
            width: '80%',
            margin: 'auto',
            fontWeight: '400'
          }}
        />

        {/* Dynamic Text 2 */}
        <InlineEdit
          value={text2}
          setValue={setText2}
          classes="wz02-text wz02-text-2"
          style={{
            fontSize: `${fontSizeText2}px`,
            fontFamily: "AveUtan",
            textAlign: "center",
            position: 'absolute',
            top: '656px',
            left: '0',
            right: '0',
            width: '80%',
            margin: 'auto',
            fontWeight: '400'
          }}
        />

        {/* Dynamic Text 3 */}
        <InlineEdit
          value={text3}
          setValue={setText3}
          classes="wz02-text wz02-text-3"
          style={{
            fontSize: `${fontSizeText3}px`,
            fontFamily: "BarlowLight",
            textAlign: "center",
            position: 'absolute',
            bottom: '308px',
            left: '0',
            right: '0',
            width: '80%',
            margin: 'auto',
            fontWeight: '400'
          }}
        />

        {/* Dynamic Text 4 */}
        <InlineEdit
          value={text4}
          setValue={setText4}
          classes="wz02-text wz02-text-4"
          style={{
            fontSize: `${fontSizeText4}px`,
            fontFamily: "BarlowLight",
            textAlign: "center",
            position: 'absolute',
            bottom: '272px',
            left: '0',
            right: '0',
            width: '80%',
            margin: 'auto',
            fontWeight: '600'
          }}
        />

        {/* Background Image */}
        <img
          className="wz02-bg"
          src="/images/Basnie02bg.svg"
          style={{ width: "100%", height: "100%", zIndex: '5', position: 'absolute', top: '0', bottom: '0', left: '0', right: '0' }}
        />
      </div>
    </div>
  );
};

export default Wz02;
